/* eslint-disable react/require-default-props */
import React, { useEffect } from 'react';
import { FormControl, FormLabel } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import { useStoreActions, useStoreState } from '../../../models/hooks';
import { MultiOption, MultiSelect } from '../../administration/positionManagement/recruiterWatchAndFollow/positions/MultiSelect';

interface LocationFilterProps {
  values: string[];
  onChange: (locations: string[], isAllSelcted: boolean) => void;
  isDisabled?: boolean;
  isSelectAll?: boolean;
}

export const LocationFilter = React.memo(function LocationFilter({
  values,
  onChange,
  isDisabled,
  isSelectAll,
}: LocationFilterProps) {
  const { t } = useTranslation('candidateSearch');

  const { locations, isLocationsfetching } = useStoreState(/* istanbul ignore next */ (state) => state.moniterByRecruiters);
  const { fetchLocations } = useStoreActions(/* istanbul ignore next */ (state) => state.moniterByRecruiters);

  useEffect(() => {
    fetchLocations().catch(console.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Map locations to generic options
  const locationOptions: MultiOption<string>[] = locations.map((loc) => ({
    value: loc.name,
    label: loc.name,
  }));

  return (
    <FormControl display="flex" flexDirection="column" isDisabled={isDisabled}>
      <FormLabel htmlFor="label" mb="0" fontSize="sm">
        {t('filters.location.label')}
      </FormLabel>
      <MultiSelect
        options={locationOptions}
        selectedValues={values ?? /* istanbul ignore next */ []}
        onChange={onChange}
        selectAll={isSelectAll ?? false}
        label={t('filters.location.label')}
        allSelectText={t('filters.location.allSelected')}
        placeholder={t('filters.location.searchPlaceholder')}
        isLoading={isLocationsfetching}
        disabled={isLocationsfetching || isDisabled}
        height={400}
        itemHeight={30}
      />
    </FormControl>
  );
});
